export default "aa52f4f27bfed350.png"